import NotificationEntry from './NotificationEntry'

export default NotificationEntry
